import { Divider, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { lightPalette } from "../../../shared/mui/palettes";
import { RootState } from "../../../store/store";

const InvoiceFrom = () => {
  const { t } = useTranslation();
  const companyData = useSelector((state: RootState) => state.companySettings);
  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ alignItems: "flex-start", marginY: "1rem" }}
      >
        <Grid size={{ xs: 12, md: 5 }}>
          <h3>{t("invoice.from")}:</h3>
          <Typography variant={"subtitle1"} color={lightPalette.text.gray}>
            {t("invoice.companyInformation")}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                value={companyData?.title}
                label={t("general.company")}
                sx={{ width: "100%" }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <TextField
                value={companyData?.phoneNumber ?? ""}
                label={t("general.phoneNumber")}
                sx={{ width: "100%" }}
                disabled
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <TextField
                value={companyData?.address ?? ""}
                label={t("general.address")}
                sx={{ width: "100%" }}
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Divider />
    </>
  );
};

export default InvoiceFrom;
